// LocalStorage key for storing lottery sessions
const STORAGE_KEY = 'lottery_sessions';

// Default sample data (only used if localStorage is empty)
const DEFAULT_SESSIONS = [
  {
    id: '1',
    type: 'paired',
    setupNumber: 5,
    drawnNumbers: [3, 1, 4],
    remainingNumbers: [1, 2, 2, 3, 4, 5, 5],
    createdAt: new Date('2025-01-15T10:30:00').toISOString(),
    completed: false
  },
  {
    id: '2',
    type: 'paired',
    setupNumber: 3,
    drawnNumbers: [2, 3, 1, 3, 2, 1],
    remainingNumbers: [],
    createdAt: new Date('2025-01-14T15:20:00').toISOString(),
    completed: true
  }
];

// Helper function to get sessions from localStorage
const getSessionsFromStorage = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      return JSON.parse(stored);
    }
    // If no data exists, initialize with default sessions
    localStorage.setItem(STORAGE_KEY, JSON.stringify(DEFAULT_SESSIONS));
    return DEFAULT_SESSIONS;
  } catch (error) {
    console.error('Error reading from localStorage:', error);
    // Fallback to default sessions if localStorage fails
    return DEFAULT_SESSIONS;
  }
};

// Helper function to save sessions to localStorage
const saveSessionsToStorage = (sessions) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(sessions));
  } catch (error) {
    console.error('Error saving to localStorage:', error);
    // If storage is full, try to remove old completed sessions
    if (error.name === 'QuotaExceededError') {
      const filtered = sessions.filter(s => !s.completed);
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(filtered));
      } catch (e) {
        console.error('Failed to save even after cleanup:', e);
      }
    }
  }
};

// Get all sessions
export const getMockSessions = () => {
  const sessions = getSessionsFromStorage();
  return [...sessions]; // Return a copy to prevent direct mutation
};

// Save a new session
export const saveMockSession = (session) => {
  const sessions = getSessionsFromStorage();
  sessions.unshift(session); // Add to beginning
  saveSessionsToStorage(sessions);
  return session;
};

// Update an existing session
export const updateMockSession = (id, updates) => {
  const sessions = getSessionsFromStorage();
  const index = sessions.findIndex(s => s.id === id);
  if (index !== -1) {
    sessions[index] = { ...sessions[index], ...updates };
    saveSessionsToStorage(sessions);
    return sessions[index];
  }
  return null;
};